import { type UpdateIntegrationSettings } from '@vy/types';
import { getModifiedFields } from '@vy/utils';
import { useCallback } from 'react';
import { useQueryClient } from 'react-query';
import { useUpdateIntegrationConfiguration } from '../../../../../../../hooks/requests/use-update-integration-configuration';
import { queryKeys } from '../../../../../../../services/query-key/query-keys';
import { runMutation } from '../../../../../../../utils/vy-mutation';

export function useModifyConfiguration() {
  const queryClient = useQueryClient();
  const updateConfigurationMutation = useUpdateIntegrationConfiguration();

  return useCallback(
    async (
      integrationId: string,
      updatedIntegrationSettings: UpdateIntegrationSettings,
      existingIntegrationSettings: UpdateIntegrationSettings,
    ) => {
      const modifiedIntegrationSettings: UpdateIntegrationSettings = {
        ...getModifiedFields(updatedIntegrationSettings, existingIntegrationSettings),
        integrationProvider: existingIntegrationSettings.integrationProvider,
      };

      await runMutation(
        updateConfigurationMutation,
        { integrationId, integrationSettings: modifiedIntegrationSettings },
        {
          pending: 'Updating Paddle configuration...',
          success: 'Paddle configuration updated',
          error: 'Failed to update Paddle configuration',
        },
        {
          onSuccess: async () => {
            await queryClient.invalidateQueries(queryKeys.integrationSettings());
          },
        },
      );
    },
    [queryClient, updateConfigurationMutation],
  );
}
